import { motion, useAnimation } from 'framer-motion';
import React, { useEffect, useLayoutEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import './homeCircel.css';
import {Link} from 'react-router-dom';

function HomeCircle() {
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    const transition = {duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96]};

    const animation = useAnimation();
    const [featuredRef, inView] = useInView({
        triggerOnce: true,
        rootMargin: '-100px'
    });
    useEffect(() => {
        if(inView) {
            animation.start("visible")
        }
    }, [animation, inView])
    return (
        <>
        <div className="homeci__div11">
            <div className="homeci__div10">
                <h3 className="home1">Click on Name :)</h3>
            </div>
            <div className="homeci__div12">
                <h3 className="home1">@Projects</h3>
            </div>
        </div>
        <div className="homeci__div1">
            <div className="homeci__div2">
                <motion.div ref={featuredRef} animate={animation} whileHover={{scale: 0.7}} transition={transition} className="homeci__div3">
                    <Link to="/carbon" style={{color: "#d9d9d9", textDecoration: "none"}}><motion.h1 className="homeci__line1">E-Commerce Website</motion.h1></Link>
                </motion.div>
                <motion.div whileHover={{scale: 0.7}} transition={transition}  className="homeci__div4">
                    <Link to="/crsa" style={{color: "#d9d9d9", textDecoration: "none"}}><h1 className="homeci__line1">Real Estate Website</h1></Link>
                </motion.div>
                <motion.div whileHover={{scale: 0.7}} transition={transition}  className="homeCi__div5">
                    <Link to="/ddd" style={{color: "#d9d9d9", textDecoration: "none"}}><h1 className="homeci__line1">Hotels Website</h1></Link>
                </motion.div>
            </div>
            <div className="homeci__div6">
                <motion.div whileHover={{scale: 0.7}} transition={transition} className="homeci__div7">
                    <Link to="/sass" style={{color: "#d9d9d9", textDecoration: "none"}}><h1 className="homeci__line1">Restaturant Website</h1></Link>
                </motion.div>
                <motion.div whileHover={{scale: 0.7}} transition={transition} className="homeCi__div8">
                    <Link to="/ak" style={{color: "#d9d9d9", textDecoration: "none"}}><h1 className="homeci__line1">IT Agency Website</h1></Link>
                </motion.div>
            </div>
            <div className="homCi__div9">
                <motion.div whileHover={{scale: 0.7}} transition={transition} className="homeCi__div10">
                    <Link to="/martin" style={{color: "#d9d9d9", textDecoration: "none"}}><h1 className="homeci__line1">Portfolio Website</h1></Link>
                </motion.div>
            </div>
        </div>
        <div className="homeci__div20"></div>
            <div className="homeProduct__div21">
                <h3 className="homeProduct__line5">INTERNATIONAL AGENCY</h3>
                <h3 className="homeProduct__line6">&copy;2021</h3>
            </div>
        </>
    )
}

export default HomeCircle;
